import barba from '@barba/core';
import { gsap } from "gsap";

import scrollLock from 'scroll-lock';

let indexLayout = null;

let fixedImage = null;
let fixedBackground = null;

let currentImage = null;
let currentImageRect = null;

let nextImage = null;
let nextImageRect = null;

export default {
	name: 'index-product',
	from: {
		custom: ({ current, next, trigger }) => {
			const mobileBreakpoint = window.matchMedia('(max-width:991px)');

			if (mobileBreakpoint.matches) {
				return false;
			}

			return true;
		},
		namespace: ['template-shop-index'],
	},
	to: {
		namespace: ['single-wps_products'],
	},
	leave({ current, next, trigger }) {
        return new Promise(resolve => {

            // Index Layout
            indexLayout = current.container.querySelector('[data-layout-elm]');
			indexLayout.classList.add('is-locked');

			document.dispatchEvent(new CustomEvent('disable-scroll'));
			document.dispatchEvent(new CustomEvent('remove-cursors'));
			barba.menu.close();

            resolve();
        });
	},
	afterLeave({ current, next, trigger }) {
		return new Promise(resolve => {

			// Current Image
			currentImage = trigger.querySelector('.img')
			currentImageRect = currentImage.getBoundingClientRect();

			// Create Fixed Elements
			fixedImage = document.createElement('div');
            fixedImage.classList.add('c-fixed-image');

            fixedBackground = document.createElement('div');
            fixedBackground.classList.add('c-fixed-background');

			const productBg = trigger.dataset.productbg;
			fixedImage.setAttribute('style', '--productbg: '+productBg+';');
			fixedBackground.setAttribute('style', '--productbg: '+productBg+';');

			gsap.set([fixedImage, fixedBackground], {
				width: currentImageRect.width,
				height: currentImageRect.height,
				left: currentImageRect.left,
				top: currentImageRect.top,
			});

			document.body.appendChild(fixedImage);
            document.body.appendChild(fixedBackground);

            const currentImageWrapper = currentImage.closest('.c-img-video');
            const currentImageWrapperRect = currentImageWrapper.getBoundingClientRect();
            gsap.set(currentImageWrapper, {
                width: currentImageWrapperRect.width,
                height: currentImageWrapperRect.height
            });

			fixedImage.appendChild(currentImage);

			// Scroll to top but make sure Current Container stays in position
			gsap.set(current.container, {
				position: 'absolute',
				width: current.container.getBoundingClientRect().width+'px',
				top: 0,
				left: 0,
				zIndex: 0
			});

			window.scrollTo(0, 0);

			// Prepare Next Container for revealing animation
			gsap.set(next.container, {
				opacity: 0,
				zIndex: 1
			});

			resolve();

		});
	},
    beforeEnter({ current, next, trigger }) {
		return new Promise(resolve => {
			// Next Image Position is Calculated in beforeEnter of the Product view, therefor the position calculations are in the Before Hook
            resolve();
        })
    },
	enter({ current, next, trigger }) {
		return new Promise((resolve) => {

            // Next Image
			const nextImageWrapper = next.container.querySelector('[data-product-first-image]');
			nextImage = nextImageWrapper.querySelector('.img');
			nextImageRect = nextImage.getBoundingClientRect();
            gsap.set(nextImage, {
                opacity: 0
            });

			const targetScale = nextImageRect.width / currentImageRect.width;

            const imageRatio = currentImageRect.width/currentImageRect.height;
            const windowRatio = window.innerWidth/window.innerHeight;
            const beforeScale = (windowRatio>imageRatio) ? window.innerWidth / currentImageRect.width : window.innerHeight / currentImageRect.height;

			const currentX = currentImageRect.x;
			const nextX = nextImageRect.x;
			const targetX = (currentX - nextX) * -1;

			const currentY = currentImageRect.y;
			const nextY = nextImageRect.y;
			const targetY = (currentY - nextY) * -1;

			const tl = gsap.timeline({
				onComplete: () => {
					resolve();
				},
			});

			tl.to(current.container, {
				opacity: 0,

				ease: 'power1.inOut',
				duration: 0.6,
				clearProps: 'zIndex',
                onComplete: () => {
					window.scrollTo(0, 0);
                    barba.menu.update(next.container);
                }
			});

            tl.addLabel('scale');

            tl.to(fixedBackground, {
                scale: beforeScale,

                ease: 'power2.inOut',
				duration: 1.2,
            }, 'scale');

			tl.to(fixedImage, {
				scale: targetScale,
				translateX: targetX + 'px',
				translateY: targetY + 'px',

				ease: 'power4.inOut',
				duration: 1.2,
			}, 'scale');


		});
	},
	afterEnter({ current, next, trigger }) {
        return new Promise(resolve => {

			// Double unlock..
			document.dispatchEvent(new CustomEvent('enable-scroll'));
			scrollLock.clearQueueScrollLocks();
			scrollLock.enablePageScroll();

			gsap.to(next.container, {
				opacity: 1,

				ease: 'power1.inOut',
				duration: 0.6,
				clearProps: 'zIndex',
				onComplete: () => {
					gsap.set(nextImage, {
                        opacity: 1
                    });

					fixedImage.remove();
                    fixedBackground.remove();

					resolve();
				}
			});

        });
	},
};
